import { SharedCommandNames } from '@chegg/commerce-utils';
import { initializeSDK } from '../../../internals/App/utils';
import { ErrorType } from '../../../constants/Errors';
import { isEmpty } from '@chegg/utils';
import { saveConfigs } from '../../ConfigState/ConfigState.actions';
import { getMopOnFile } from '../../MopOnFileState/MopOnFileState.actions';
import { saveUserAddressCommands } from '../CommandState.actions';
/**
 * Util to reauthorize checkout sdk client
 * @param params
 * @returns
 */
export var reauthorizeCommand = function reauthorizeCommand(params) {
  var state = params.state,
    command = params.command,
    dispatch = params.dispatch;
  var mopOnFile = state.mopOnFile;
  if (!command.data || isEmpty(command.data)) return;
  var data = command.data;
  initializeSDK(data);
  var errors = mopOnFile.errors;

  //The following will retry fetching a user's MOPs if the call to get MOPs was unsuccessful.
  if (errors !== null && errors !== void 0 && errors.find(function (error) {
    return error.type === ErrorType.AUTHORIZATION;
  })) {
    dispatch(getMopOnFile({}));
  }
  dispatch(saveConfigs({
    authorization: data
  }));
  dispatch(saveUserAddressCommands([{
    commandName: SharedCommandNames.REAUTHORIZE,
    data: data
  }]));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/commands/reauthorizeCommand.js
// module id = 4525
// module chunks = 11